var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.name == 'GradeCourseTotal')?_c('div',{staticClass:"gradeCourseTotal",attrs:{"id":"gradeCourseTotal"}},[_vm._v("1")]):_vm._e(),(_vm.name == 'stateInfo')?_c('div',{staticClass:"applicationData",attrs:{"id":"applicationData"}},[_vm._v("2")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }